import React from 'react';
import { BRAND, isMarketGB } from '../../../constants/main';
import { BasketMandatoryFeesDetailsAC } from './AC/BasketMandatoryFeesDetails.AC';
import { BasketMandatoryFeesDetailsOV } from './OV/BasketMandatoryFeesDetails.OV';
import { BasketMandatoryFeesDetailsAP } from './AP/BasketMandatoryFeesDetails.AP';
import { BasketMandatoryFeesDetailsDS } from './DS/BasketMandatoryFeesDetails.DS';
import { BasketMandatoryFeesDetailsOV as BasketMandatoryFeesDetailsOV_GB } from './OV/GB/BasketMandatoryFeesDetails.OV';
import { BasketMandatoryFeesStyled } from './BasketMandatoryFeesStyled';
import { SC } from '../../../styles/theme';

export type BasketMandatoryFeesDetailsProps = SC & {
    generatedIndex?: number;
};

const BasketMandatoryFeesDetails = (props: BasketMandatoryFeesDetailsProps) => {
    if (BRAND === 'AC') return <BasketMandatoryFeesDetailsAC {...props} />;
    if (BRAND === 'OV')
        return isMarketGB ? (
            <BasketMandatoryFeesDetailsOV_GB {...props} />
        ) : (
            <BasketMandatoryFeesDetailsOV {...props} />
        );
    if (BRAND === 'AP') return <BasketMandatoryFeesDetailsAP {...props} />;
    if (BRAND === 'DS') return <BasketMandatoryFeesDetailsDS {...props} />;
    return <BasketMandatoryFeesStyled {...props} />;
};

export default BasketMandatoryFeesDetails;
